import React, { useEffect } from 'react'

export const useRefreshKlarnaBanners = (price) => {
  useEffect(() => {
    const service = window.KlarnaOnsiteService || []
    service.push({ eventName: 'refresh-placements' })
  }, [price])
}
